export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'stocks',
      displayName: 'Stocks',
      isLink: true,
      showSubItems: true,
      meta: {
        icon: 'stock',

      },
      children: [

      ],
    },
    {
      name: 'categories',
      displayName: 'menu.categories',
      isLink: true,
      showSubItems: false,
      meta: {
        icon: 'stock',
      },
      children: [
        {
          name: 'category-list',
        },
        {
          name: 'category-edit',
          displayName: 'menu.edit-category',
        },
        {
          name: 'category-create',
          displayName: 'menu.create-category',
        },
      ],
    },
    {
      name: 'orders',
      displayName: 'menu.orders',
      meta: {
        icon: 'order',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'users',
      },
    },
    // {
    //   name: 'dashboard',
    //   displayName: 'menu.dashboard',
    //   meta: {
    //     icon: 'vuestic-iconset-dashboard',
    //   },
    // },
    // {
    //   name: 'projects',
    //   displayName: 'menu.projects',
    //   meta: {
    //     icon: 'folder_shared',
    //   },
    // },
    // {
    //   name: 'payments',
    //   displayName: 'menu.payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'menu.payment-methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'menu.pricing-plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'menu.billing',
    //     },
    //   ],
    // },
    // {
    //   name: 'auth',
    //   displayName: 'menu.auth',
    //   meta: {
    //     icon: 'login',
    //   },
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'menu.login',
    //     },
    //     {
    //       name: 'signup',
    //       displayName: 'menu.signup',
    //     },
    //     {
    //       name: 'recover-password',
    //       displayName: 'menu.recover-password',
    //     },
    //   ],
    // },

    // {
    //   name: 'faq',
    //   displayName: 'menu.faq',
    //   meta: {
    //     icon: 'quiz',
    //   },
    // },
    // {
    //   name: '404',
    //   displayName: 'menu.404',
    //   meta: {
    //     icon: 'vuestic-iconset-files',
    //   },
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    {
      name: 'actions',
      displayName: 'menu.actions',
      meta: {
        icon: 'order',
      },
    },
    {
      name: 'shipping',
      displayName: 'menu.shipping',
      meta: {
        icon: 'shipping',
      },
    },
    {
      name: 'tracking',
      displayName: 'menu.tracking',
      meta: {
        icon: 'tracking',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'setting',
      },
    },
  ] as INavigationRoute[],
}
